<template>
	<div class="not-found">404</div>
</template>

<script>
export default {
	name: "NotFound"
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.not-found {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	font-size: 66px;
	color: $primary-color;
}
</style>
